<template>
  <div class="mobile-payment-edit">
      <div class="section">
        <div class="container">
          <div>
            <h2>ご登録中のカード情報</h2>
            <div class="main-area">
              <dl class="columns">
                <dt>カード情報</dt>
                <dd>{{ contract.brand }}</dd>
              </dl>
              <dl class="columns">
                <dt></dt>
                <dd>{{ contract.cardInfo }}</dd>
              </dl>
              <dl class="columns">
                <dt>有効期限</dt>
                <dd>{{ contract.exp }}</dd>
              </dl>
              <dl class="columns">
                <dt>次回決済予定日</dt>
                <dd>{{ contract.nextDatetime }}</dd>
              </dl>
            </div>
            <div class="sub-area">

            </div>
            <div
              id="message-area"
              class="error-message mdi mdi-alert-circle-outline"
              v-if="errorMessage"
            >
              {{ errorMessage }}
            </div>
            <div
              id="message-area"
              class="information-message mdi mdi-check-circle-outline"
              v-if="message"
            >
              {{ message }}
            </div>
            <div class="card-area" :class="{ 
              complete: cardInput
            }">
              <div ref="payjpArea"></div>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Loader from "@/mixins/loader";
import { PAYMENT, PAYMENT_RESULT_CODE, MENU_CODE, OPERATION_TYPE } from "@/constants/constants";
import Contract from "@/mixins/contract";

export default {
  props:{

  },

  data() {
    return {
      cardInput: false,
      errorMessage: null,
      message: null,
      contract: {
        brand: null,
        cardInfo: null,
        exp: null,
        nextDatetime: null,
      }
    };
  },

  mixins: [Loader, Contract],
  components: {},
  created() {},

  async mounted() {
    this.loading(async () => {
      this.cardInput = false;
      await this.showCardInfo();

      document.getElementById('container').scrollIntoView({
          behavior: 'instant',
          block: 'start'
      });
      await this.accessLogs({
        menu: MENU_CODE.CARD_CHANGE,
        ope: OPERATION_TYPE.Menu,
      });
    });
  },

  beforeDestroy() {
    try {
      this.destoryPayjp();
    } catch(e) {
      console.log(e);
    }
  },

  methods: {
    ...mapActions(["accessLogs", "showAccount", "showAccountID", "showUserId", "showCard", "updateCard"]),
    ...mapGetters(["getAccountID"]),

    appendPayJpScriptTag() {
      const attrs = {
        "data-payjp-key": PAYMENT.KEY,
        id: "payjp-script",
        src: "https://checkout.pay.jp/",
        class: "payjp-button",
        "data-payjp-text": "カード情報を変更する",
        "data-payjp-submit-text": "カード情報を変更する",
        "data-payjp-lang": "ja",
        "data-payjp-token-name":"payjp-token",
        "data-payjp-three-d-secure":"true",
        "data-payjp-three-d-secure-workflow":"subwindow",
        "data-payjp-extra-attribute-email":"",
        "data-payjp-extra-attribute-phone":"",
        "data-payjp-extra-attribute-phone-code":"JP",
        "data-payjp-partial":"true",
        "data-payjp-on-created":"onTokenCreated",
        "data-payjp-on-failed":"onTokenFailed",
      };
      this.scriptEl = document.createElement("script");
      for (let key in attrs) {
        this.scriptEl.setAttribute(key, attrs[key]);
      }
      this.$refs.payjpArea.appendChild(this.scriptEl);
    },
    onTokenCreated() {
      this.loading(async () => {
        let token = document.getElementsByName("payjp-token")[0].value;
        this.errorMessage = null;
        this.message = null;
        this.cardInput = true;
        try {
          const ret = await this.updateCard({ token: token });
          // 同じカードの場合
          if (ret.data.status === 203) {
            this.message = "すでに登録されているカードと同じです。変更するカード情報を再確認してください。";
            this.$router.push({ name: "mobile-payment-edit-complete", params:{result: PAYMENT_RESULT_CODE.Retry, message: this.message} });
          }
          else {
            this.message = "";
            this.$router.push({ name: "mobile-payment-edit-complete", params:{result: PAYMENT_RESULT_CODE.Success, message: this.message} });
          }
        } catch (err) {
          this.errorMessage =
            "カード情報の変更ができませんでした。";
          this.$router.push({ name: "mobile-payment-edit-complete", params:{result: PAYMENT_RESULT_CODE.Retry, message: this.errorMessage} });
          return;
        }
      });
    },
    onTokenFailed(res) {  // eslint-disable-line no-unused-vars
      // 処理
      this.errorMessage =
        "カード情報の変更ができませんでした。";
      this.$router.push({ name: "mobile-payment-edit-complete", params:{result: PAYMENT_RESULT_CODE.Retry, message: this.errorMessage} });
      this.cardInput = false;
    },

    async showCardInfo() {
      const aid = await this.showAccountID();
      const uid = await this.showUserId();
      const accountInfo = await this.showAccount(aid);
      if (accountInfo.root_users && accountInfo.root_users.length > 0) {
        const isRootUser = accountInfo.root_users[0] === uid;
        if (isRootUser) {
          const isFreePlan = this.isAccountFree(accountInfo);
          if (!isFreePlan) {
            const cardInfo = await this.showCard();
            this.contract.brand = cardInfo.brand;
            this.contract.cardInfo = this.parseCardInfo(cardInfo);
            this.contract.exp = this.parseExp(cardInfo);
            this.contract.nextDatetime = cardInfo.subscription_next;

            this.appendPayJpScriptTag();
            window.onTokenCreated = this.onTokenCreated;
            window.onTokenFailed = this.onTokenFailed;
          }
        }
      }
    },

    destoryPayjp() {
      const payjpCheckoutIframeEl = document.getElementById(
        "payjp-checkout-iframe"
      );
      if (payjpCheckoutIframeEl) {
        payjpCheckoutIframeEl.parentElement.remove();
      }
      try {
        this.$refs.payjpArea.removeChild(this.scriptEl);
      } finally {
        window.PayjpCheckout = null;
        window.onTokenCreated = null;
        window.onTokenFailed = null;
      }
    },

    parseCardInfo(cardInfo){
      var ret;
      if (cardInfo && cardInfo.last4) {
        ret = "**** **** **** " + cardInfo.last4;
      }
      return ret;
    },
    parseExp(cardInfo){
      var ret;
      if (cardInfo && cardInfo.last4) {
        const month = ( '00' + cardInfo.exp_month ).slice( -2 );
        ret = month + "/" + cardInfo.exp_year;
      }
      return ret;
    }
  },
};
</script>

<style lang="scss">
.mobile-payment-edit {
  .section {
    overflow: auto;
    width: 100%;
    height: 100%;
    position: relative;
    margin: auto;
    background: white;

    .container {
      margin: 2rem;

      h2 {
        text-align: center;
        font-weight: 400;
      }

      .main-area {
        text-align: center;
      }

      .main-area ul {
        list-style-type: none;
        padding-inline: unset;
      }

      .sub-area {
        margin-top: 1rem;

      }
      dl.columns {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 1fr;
        align-items: top;
        grid-gap: 0px 0px;
        margin: 0;
        padding: 0;
        color: #333;
      }
      dl.columns.td-check {
          grid-template-columns: 40px auto;
      }

      .columns dt {
        display: block;
        text-align: left;
        width: 100%;
        margin: 0;
        padding: 10px;
      }

      .columns dd {
        display: block;
        width: 100%;
        border-left: solid 1px #ddd;
        margin: 0;
        padding: 10px;
        text-align: left;
      }
      .columns dt:nth-of-type(odd) {
        background: #f3f3f3;
      }
      .columns dd:nth-of-type(odd) {
        background: #f3f3f3;
      }
    }
  }
  .card-area {
    text-align: center;
    margin-top: 2rem;
  }
  .card-area.complete {
    display: none;
  }
  #payjp_checkout_box input[type="button"] {
    font-size: 16px;
  }
  #message-area {
    margin-top: 2rem;
  }

  .ex-card-area-disable {
    opacity: 0.5;
    pointer-events: none;
    cursor: none;
  }
}
</style>
